<div class="ub-stepper">
  <ub-grid gap="0px" [template]="gridTemplate()">
    <div *ngFor="let step of _steps" [ngClass]="stepClassNames(step)" (click)="expand(step)">
      <span class="ub-stepper__step__title">{{ stepTitle(step.title) }}</span>
      <span class="ub-stepper__step__status">
        <ub-label variant="none" text="{{ stepStatus(step) }}"></ub-label>
      </span>
      <ub-grid *ngIf="showSubSteps(step)" direction="row" gap="0px" template="1fr">
        <div *ngFor="let step of step.steps" [ngClass]="stepClassNames(step, true)">
          <span class="ub-stepper__step__title">{{ stepTitle(step.title) }}</span>
          <span class="ub-stepper__step__status">
            <ub-label variant="none" text="{{ stepStatus(step) }}"></ub-label>
          </span>
        </div>
      </ub-grid>
    </div>
  </ub-grid>
</div>
